/* unplugin-vue-components disabled */import { render } from "./support_project.vue?vue&type=template&id=e39fbdc8&scoped=true"
import script from "./support_project.vue?vue&type=script&lang=js"
export * from "./support_project.vue?vue&type=script&lang=js"

import "./support_project.vue?vue&type=style&index=0&id=e39fbdc8&lang=less&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/prod-fe.pro/src/fe-pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e39fbdc8"]])

export default __exports__